import angular from 'angular';
import wageAdvanceInfoComponent from './wageAdvanceInfo.component';

let wageAdvanceInfoModule = angular.module('wageAdvanceInfo', [
])

.component('wageAdvanceInfo', wageAdvanceInfoComponent)

.name;

export default wageAdvanceInfoModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceInfo/wageAdvanceInfo.js